export default __webpack_public_path__ + "static/media/ic_avalanche_testnet_16.32340c73.svg";